import { flowRight } from 'lodash';
import { connect } from 'react-redux';

import withHocName from '../../app/hoc/with-hoc-name';
import { getWidgetPostsProps } from '../services/widget-posts-props';

const mapStateToProps = getWidgetPostsProps;

// prettier-ignore
export default function (Component) {
  return flowRight(
    connect(mapStateToProps),
    withHocName('WithFeedPostsProps')
  )(Component);
}
